import axiosClient from "./axiosClient";

export const getClassroomsOfSchool = async (selectedDate) => {
  const response = await axiosClient.get("/Manager/Absence/GetClassrooms/" + selectedDate);
  return response.data;
};

export const getTodayClassroomsOfSchool = async () => {
  const response = await axiosClient.get("/Manager/Absence/GetClassroomsOfToday");
  return response.data;
};

export const addClassroom = async (name) => {
  const response = await axiosClient.post("/Manager/Absence/AddClassroom", { name });
  return response.data;
};

export const updateClassroom = async (classroomId, name) => {
  const response = await axiosClient.put("/Manager/Absence/UpdateClassroom/" + classroomId, { name });
  return response.data;
};

export const deleteClassroom = async (classroomId) => {
  const response = await axiosClient.delete("/Manager/Absence/DeleteClassroom/" + classroomId);
  return response.data;
};